import React, { useContext } from 'react'
import TipLine from 'app/React/Components/Main/TipLine'
import Usps from 'app/React/Components/Main/Usps'
import StepImage from 'app/React/Components/Main/StepImage'
import ColorImage from 'app/React/Components/Main/ColorImage'
import clx from 'classnames'
import { InteriorImage } from 'app/React/Components/Widget/InteriorImage'
import PropTypes from 'prop-types'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function StepFigure(props) {
  const {
    colorImage,
    currentStep,
    currentVariant,
    isDealerConfigurator,
    interiorImage
  } = useContext(ConfiguratorContext)

  const mandatoryInformation = currentVariant.mandatory_information ?? null
  const steps = currentVariant.steps ?? {}

  if (props.step == null) {
    return null
  }

  let layout = 'contain'
  if (interiorImage?.interior_image_url) {
    layout = 'full'
  }

  if (typeof interiorImage === 'undefined' || interiorImage === null) {
    if (currentStep != 1) {
      if (typeof steps[currentStep].image_url === 'undefined' && typeof colorImage !== 'undefined' && colorImage !== null) {
        layout = 'contain'
      } else {
        layout = 'full'
      }
    }

    if (typeof colorImage === 'undefined' || colorImage === null) {
      layout = 'full'
    }
  }

  return (
    <figure layout={layout}>
      <TipLine step={props.step}/>

      <InteriorImage>
        {props.step == 1 ? (
          <ColorImage>
            <StepImage step={props.step}/>
          </ColorImage>
        ) : (
          <StepImage step={props.step}/>
        )}
      </InteriorImage>

      {props.usps === true ? <Usps/> : null}

      {
        !isDealerConfigurator && [1, 2, 3, 4].includes(parseInt(props.step)) ? (
          <div
            className={clx('mandatory-information', props.classNames)}
            dangerouslySetInnerHTML={{ __html: mandatoryInformation }}
          />
        ) : null
      }
    </figure>
  )
}

StepFigure.defaultProps = {
  usps: true,
  step: null,
  layout: 'contained' // full
}

StepFigure.propTypes = {
  step: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  usps: PropTypes.bool,
  layout: PropTypes.string
}
